import { v1, v4 } from 'uuid'

export const regex = {
  numeric: /^[0-9]*$/,
  numericfloat: /^\d*\.?\d*$/,
  alphanumeric: /^[\w\s]*$/, //czech republic has pincode with space hence using this regex
  mobileNumber: /^[0-9]*$/,
  alternateMobileNumber: /^[0-9]*$/,
  email: /^[A-Za-z0-9](\.?[A-Za-z0-9_-]){0,}@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6}$/,
  mobileNumberOrPhone: /^([0-9]*|[A-Za-z0-9](\.?[A-Za-z0-9_-]){0,}@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6})$/,
  tag: /^(([a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]+)([.\-' ]*))*$/,
  userName: /^[\w\-\s]+$/, //\w same as [A-Za-z0-9_],
  descriptionOfLoss: /^.{30,500}$/,
  theftDetails: /^.{30,500}$/,
  lossDetails: /^.{30,500}$/,
  string: /^[A-Za-z0-9-]*$/,
}

export const isMobileNumberValid = (value, countryCode, length) => {
  if (value?.length === length) {
    // const PNT = require('google-libphonenumber').PhoneNumberType //To check the type of number
    const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance()
    const phoneNumber = phoneUtil.parseAndKeepRawInput(value, countryCode)
    return phoneUtil.isValidNumberForRegion(phoneNumber, countryCode)
  }
  return true
}

export const initialLengths = {
  otp: [6],
}

export const validateAllowedValues = (field, allowedValues) => {
  const isValueAllowed = allowedValues.some((allowValue) => {
    if (allowValue.extraFilter === 'Custom') {
      return new RegExp(allowValue.pattern).test(field) && field.length === (allowValue.length || allowValue.maxLength)
    }
    return regex[allowValue.extraFilter.toLowerCase()].test(field) && field.length === (allowValue.length || allowValue.maxLength)
  })
  return isValueAllowed
}

export const getFilteredAllowedValues = (allowedValues, value) => {
  const types = allowedValues.map((allowValue) => allowValue.type)
  let key = types.includes('SerialNumber') ? (types.includes('IMEI') ? 'IMEIorSerial' : 'SerialNumber') : 'IMEI'

  if (key === 'IMEIorSerial') {
    key = /[A-Za-z]+/.test(value) ? 'SerialNumber' : 'IMEI'
  }

  return allowedValues.filter((allowedValue) => allowedValue.type === key)
}

export const validateValues = (formFields, optionalFields = {}, lengths = {}, customRegex = {}) => {
  lengths = { ...initialLengths, ...lengths }
  customRegex = { ...regex, ...customRegex }
  let error = {}
  let isEmpty = false
  let isValid = true
  Object.keys(formFields).forEach((formField) => {
    if (!optionalFields[formField]) {
      if (customRegex[formField]) {
        const _regex = new RegExp(customRegex[formField])
        const regexTest = _regex.test(formFields[formField]?.toString().trim())
        if (!regexTest) {
          isValid = false
          error[formField] = 'Invalid format'
        }
      }
      if (lengths[formField]) {
        if (!Array.isArray(lengths[formField])) {
          lengths[formField] = [lengths[formField]]
        }
        if (lengths[formField] !== 524288 && !lengths[formField].includes(formFields[formField]?.length)) {
          isValid = false
          error[formField] = `Minimum characters required`
        }
      }
      if (Array.isArray(formFields[formField]) && !formFields[formField].length) {
        isValid = false
        isEmpty = true
        error[formField] = 'Field is required'
      }
      if (
        typeof formFields[formField] === 'object' &&
        typeof formFields[formField]?.getDate !== 'function' && //to check if the object is not a Date Object
        formFields[formField] !== null &&
        !Object.keys(formFields[formField]).length
      ) {
        isValid = false
        isEmpty = true
        error[formField] = 'Field is required'
      }
      if (!formFields[formField]) {
        isValid = false
        isEmpty = true
        error[formField] = `Field is required`
      }
    }
  })
  return { isValid, isEmpty, error }
}

export const formatTime = (date) => {
  const dateObject = new Date(date)
  var timeString = dateObject.toTimeString().split(':')
  return `${('0' + (timeString[0] % 12 || 12)).slice(-2)}:${timeString[1]} ${timeString[0] < 12 ? 'AM' : 'PM'}`
}

export const docServiceModuleName = 'Consumer-Web'

export const createDocumentRequestObject = (file, documentType) => {
  let uniqueId = v1()
  let clientRefId = v4()
  let payload = new FormData()
  payload.append('docType', documentType)
  payload.append('file', file)
  payload.append('clientRefId', clientRefId)
  payload.append('entity-id', uniqueId)
  payload.append('entity-type', documentType)
  payload.append('module', docServiceModuleName)
  return payload
}

export const localFieldToDBFieldMapping = {
  serialNumber: 'SerialNumber',
  imei1: 'IMEI',
  imei2: 'IMEI',
}
